export { setPwaUpdater, requestPwaUpdate } from './pwa-updater'

export async function forcePwaReset(): Promise<void> {
  const registrations = await navigator.serviceWorker.getRegistrations()
  await Promise.all(
    registrations.map((registration) => registration.unregister()),
  )

  const cacheNames = await caches.keys()
  await Promise.all(
    cacheNames
      .filter((cacheName) => cacheName.startsWith('workbox-'))
      .map((cacheName) => caches.delete(cacheName)),
  )
  window.location.reload()
}

export function getPwaDisplayMode(): 'installed' | 'browser' {
  return window.matchMedia('(display-mode: standalone)').matches
    ? 'installed'
    : 'browser'
}
